import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { CommonModule } from '@angular/common'
import { AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, inject } from '@angular/core'
import {
	AbstractComponent,
	getClient,
	InfiniteScrollService,
	isLoadingGetVenues,
	LoginHomologationDirective,
	VenueActions,
} from '@monorepo-channels/channels/domain'
import { SwiperUiComponent } from '@monorepo-channels/components/ui-porto-bank'
import { VenueCardListComponent } from '../venue-card-list/venue-card-list.component'
import { DataLayerService, isMobile, MenuOpened } from '@monorepo-channels/shared/util-helpers'
import { FilterComponent } from '../filter/filter.component'

type Slide = {
	title: string
	text?: string
	buttonText?: string
	imageDesktop: string
	imageMobile: string
	click: VoidFunction
	alt: string
	removeWhenLoggedIn: boolean
}

@Component({
	standalone: true,
	imports: [CommonModule, SwiperUiComponent, VenueCardListComponent, FilterComponent],
	templateUrl: 'venues-list.component.html',
	styleUrls: ['venues-list.component.scss'],
	selector: 'feature-porto-bank-venues-list',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	hostDirectives: [LoginHomologationDirective],
})
export class VenueListComponent extends AbstractComponent implements OnInit, AfterViewInit {
	public banners: Slide[] = []
	public menuOpened = inject(MenuOpened)
	override isMobile = isMobile()
	private InfiniteScrollService = inject(InfiniteScrollService)
	showBottomButton = false
	private dataLayerService = inject(DataLayerService)
	isLoading$ = this.store.select(isLoadingGetVenues)

	constructor() {
		super()
		this.store
			.select(getClient)
			.pipe(takeUntilDestroyed())
			.subscribe(() => {
				this.banners = [
					{
						title: '',
						text: '',
						imageDesktop:
							'https://static.tagme.com.br/pubimg/Channels/Porto/banner_portobank_desk.png',
						imageMobile:
							'https://static.tagme.com.br/pubimg/Channels/Porto/banner_portobank_mobile.png',
						click: () => {},
						alt: 'imagem que ilustra as vantagens exclusivas Gastronomia Porto Bank',
						removeWhenLoggedIn: false,
					},
				]
			})
	}

	ngOnInit(): void {
		this.store.dispatch(VenueActions.resetSelectedVenue())
		this.dataLayerService.logEvent({
			event: 'screen_view',
			screen_name: 'Gastronomia Porto Bank',
		})
	}

	private sidenavContent: HTMLElement | null = null
	private scrollHandler = () => {
		const scrollPosition = this.sidenavContent?.scrollTop || window.scrollY
		this.showBottomButton = scrollPosition > 500
	}

	ngAfterViewInit() {
		this.sidenavContent =
			document.getElementById('portoBankMainScroll') ??
			(document.querySelector('mat-sidenav-content') as HTMLElement | null)

		if (this.sidenavContent) {
			this.sidenavContent.addEventListener('scroll', this.scrollHandler)

			this.InfiniteScrollService.setScrollTarget(this.sidenavContent)
		}

		window.addEventListener('scroll', this.scrollHandler)

		this.scrollHandler()
	}
}
